import React from 'react';
import { Link, Stack, Typography, useTheme } from "@mui/material";
import { useWhiteLabelling } from "hooks/useWhiteLabelling";
import InspectifyLogoSvg from '@inspectify/design/assets/brands/inspectify/InspectifyLogoColor.svg'
import InspectifyLogoWhiteSvg from '@inspectify/design/assets/brands/inspectify/InspectifyLogoWhite.svg'

export const PoweredBySection = () => {
  const whiteLabelling = useWhiteLabelling();
  const theme = useTheme();

  if (!whiteLabelling.enabled || !whiteLabelling.showPoweredByInspectify) return null;

  return <Stack>
    <Stack sx={{ textAlign: 'left', width: '100%', marginBottom: '24px' }}>
      <Typography variant='caption'>Powered by</Typography>
      {/*// @ts-ignore*/}
      <img src={theme.palette.mode === 'dark' ? InspectifyLogoWhiteSvg : InspectifyLogoSvg} width={150} alt="Inspectify" />
    </Stack>

    <Stack sx={{ textAlign: 'left', width: '100%' }}>
      <Link
        href={`mailto:${whiteLabelling.email}`}
        target="_blank"
        rel="noreferrer">
        {whiteLabelling.email}
      </Link>
      <Link
        href={whiteLabelling.phoneNumberLink}
        target="_blank"
        rel="noreferrer">
        {whiteLabelling.formattedPhoneNumber}
      </Link>
    </Stack>
  </Stack>
}